import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Result } from 'app/main/shared/result';
import { environment } from 'environments/environment';
import { map } from 'rxjs/operators';

const CREATE_ACTION = 'AddAssetCategoryData';
const UPDATE_ACTION = 'UpdateAssetCategoryData';
const DELETE_ACTION = 'DeleteAssetCategoryData';

@Injectable({
  providedIn: 'root'
})
export class AssetcategoryService {

  constructor(private http: HttpClient) { }
  
  public GetAll(data: any)
    {
         return this.http.post<Result>(`${environment.apiUrl}/AssetCategory/GetAssetCategoryData`,data);
    }

   
    

    public Save(data: any, isNew?: boolean) {
      const action = isNew ? CREATE_ACTION : UPDATE_ACTION;
       return this.http.post<any>(`${environment.apiUrl}/AssetCategory/${action}`, data)
          .pipe(map(user => {
              return user;
          }));
    }

    public Delete(data: any) {
        const action = DELETE_ACTION;
       //var deleteassetcategoryid:number = data.id;
   
        return this.http.post<any>(`${environment.apiUrl}/AssetCategory/DeleteAssetCategoryData` ,data)
            .pipe(map(user => {
                return user;
            }));
      }

      public GetMovableValue() {         
        return this.http.post<any>(`${environment.apiUrl}/AssetCategory/GetIsMovable`,0)   
         
       }

       public GetAssetType() {
         return this.http.post<any>(
           `${environment.apiUrl}/AssetCategory/GetAssetType`,0
             
         );
       }

       public IsVehicleSubAsset() {
         return this.http.post<any>(
           `${environment.apiUrl}/AssetCategory/GetIsVehicleSubAsset`,0);
       }
     
}
